/* eslint-disable flowtype/require-parameter-type */

import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Link } from '@latitude/link';
import { Text } from '@latitude/text';
import { Box } from '@latitude/box';
import { Tel } from '@latitude/tel';
import {
  SOFT_QUOTE_LOANS_AU_RETRIEVE_URL,
  ALIGN,
  BREAKPOINT,
  COLOR,
  MARGIN,
  LOAN_PAY_FREQUENCY,
  FONT_FAMILY,
  PL_SYMPLE_MINIMUM_AMOUNT,
  PL_BROKER_MINIMUM_AMOUNT,
  PL_MAXIMUM_AMOUNT,
  PL_BROKER_MAXIMUM_AMOUNT,
  FONT_WEIGHT,
  PL_TEL,
  FONT_SIZE
} from '@/utils/constants';
import { getUrlFromEnv } from '../../utils/getUrlFromEnvUtil';
import { formatAsCurrency } from '../../utils';

import Select from '../Select/Select';
import CurrencyInput from '../CurrencyInput/CurrencyInput';
import ConfettiText from '../ConfettiText/ConfettiText';

const Container = styled(Box)`
  @media (min-width: ${BREAKPOINT.SM}) and (max-width: ${BREAKPOINT.MD}) {
    width: 100%;

    margin-left: auto;
    margin-right: auto;
  }

  ${props =>
    props.stickyQuote &&
    css`
      margin: 0 -32px 0 -8px;

      @media (min-width: ${BREAKPOINT.SM}) and (max-width: ${BREAKPOINT.MD}) {
        width: auto;
        max-width: none;
        margin: 0 -32px 0 -8px;
        /* max-width: 540px; */
      }
    `};
  height: 100%;
`;

const MainContent = styled(Box)`
  width: 100%;
  height: 100%;
  background-color: ${COLOR.BLUE_BABY};
  padding: 1em 1.5em 0em;
  height: auto;
  padding: 1.5em;
  padding-bottom: 0.5em;
  border: 1px solid ${COLOR.GREY4};
  border-bottom: 0px;

  ${props =>
    props.stickyQuote &&
    css`
      background-color: #eff7ff;
      padding: 0 0;
      border: none;
    `};
`;

const FormFields = styled(Box)`
  max-width: 300px;
  margin: auto;
  ${props =>
    !props.main &&
    !props.broker &&
    css`
      display: flex;
      flex-direction: column;
    `}
  @media (min-width: ${BREAKPOINT.XL}) {
    ${props =>
      props.main &&
      css`
        max-width: 100%;
        display: flex;
        justify-content: space-between;
      `}
  }

  ${props =>
    props.stickyQuote &&
    css`
      background-color: #eff7ff;
      padding: 0 0;
      border: none;
    `};
`;

const BorrowAmount = styled.div`
  @media (min-width: ${BREAKPOINT.XL}) {
    flex: 0 1 calc(30% - 8px);
  }
  .currency-input__error-message {
    text-align: left !important;
  }
  ${props =>
    props.stickyQuote &&
    css`
      background-color: #eff7ff;
      padding: 0 0;
      border: none;
    `};
`;

const RepaymentPeriod = styled.div`
  @media (min-width: ${BREAKPOINT.XL}) {
    ${props =>
      props.main &&
      css`
        flex: 0 1 calc(30% - 8px);
        // @media (min-width: ${BREAKPOINT.XL}) {
        //   padding-left: 15px;
        // }
      `}
  }
`;

const Title = styled.h5`
  font-size: 20px;
  line-height: 1.2;
  text-align: ${ALIGN.CENTER};
  color: ${COLOR.BLACK};
  margin-top: 0;
  margin-bottom: ${MARGIN.M16};
  font-family: ${FONT_FAMILY.TITLE};
`;

const Footer = styled(Box)`
  background-color: ${COLOR.BLUE_SKY};
  padding: 0.5em 1.5em;
  border: 1px solid ${COLOR.GREY4};
  border-top: 0px;
`;

const ResultInfoContainer = styled.div`
  background-color: #b8f3fb;
  padding: 8px;
  margin-bottom: 16px;
  @media (max-width: ${BREAKPOINT.LG_DOWN}) {
    margin-top: -8px !important;
  }
`;

const StyledText = styled(Text)`
  font-family: ${FONT_FAMILY.TITLE} !important;
  line-height: 22px;
`;

export const purposeOptions = [
  { value: 'purpose', text: 'Select...' },
  { value: 'car-purchase', text: 'Car purchase' },
  { value: 'car-repairs', text: 'Car repairs' },
  { value: 'debt-consolidation', text: 'Debt consolidation' },
  { value: 'educational-expenses', text: 'Educational expenses' },
  { value: 'home-improvements', text: 'Home improvements' },
  {
    value: 'household-furnishings',
    text: 'Household furnishings'
  },
  { value: 'medical-dental', text: 'Medical / Dental' },
  {
    value: 'other-vehicle-purchase',
    text: 'Other vehicle purchase'
  },
  { value: 'small-debts', text: 'Small debts' },
  { value: 'travel', text: 'Travel' },
  { value: 'other', text: 'Other' }
];

export const repaymentPeriodOptions = [
  { value: '2', text: '2 years' },
  { value: '3', text: '3 years' },
  { value: '4', text: '4 years' },
  { value: '5', text: '5 years' },
  { value: '6', text: '6 years' },
  { value: '7', text: '7 years' }
];

export const frequencyOptions = [
  { value: LOAN_PAY_FREQUENCY.WEEKLY, text: 'Week' },
  { value: LOAN_PAY_FREQUENCY.FORTNIGHTLY, text: 'Fortnight' },
  { value: LOAN_PAY_FREQUENCY.MONTHLY, text: 'Month' }
];

const amountLessThanMinMessage = plMinAmount => {
  return (
    <Text color={COLOR.TEXT_ERROR} fontWeight={FONT_WEIGHT.NORMAL}>
      Loan amount must be at least {formatAsCurrency(plMinAmount)}
    </Text>
  );
};

const showBrokerFeeEmptyError = errorMessage => {
  return (
    <Text color={COLOR.TEXT_ERROR} fontWeight={FONT_WEIGHT.NORMAL}>
      {errorMessage}
    </Text>
  );
};

const showBrokerFeeGreaterThan990Error = () => {
  return (
    <Text color={COLOR.TEXT_ERROR} fontWeight={FONT_WEIGHT.NORMAL}>
      Broker fee must be less than {formatAsCurrency(990)} and no more than 15%
      of loan amount
    </Text>
  );
};

const amountMoreThanMaxMessage = (plMaxAmount, isBroker) => {
  return (
    <Text color={COLOR.TEXT_ERROR} fontWeight={FONT_WEIGHT.NORMAL}>
      {`For loan amounts more than ${formatAsCurrency(plMaxAmount)} `}{' '}
      {isBroker ? (
        <>please contact your Latitude BDM</>
      ) : (
        <>
          please call us on <Tel color={COLOR.TEXT_ERROR} no={PL_TEL} />, Mon -
          Fri, 8am - 7pm (AEST){' '}
        </>
      )}
    </Text>
  );
};

const validateLoanAmount = (amountValue, isBroker) => {
  let isError;
  let isWarning;
  let message = '';

  // determine minimum loan amount for product
  const plMinAmount = isBroker ? PL_BROKER_MINIMUM_AMOUNT : PL_SYMPLE_MINIMUM_AMOUNT;
  const plMaxAmount = isBroker ? PL_BROKER_MAXIMUM_AMOUNT : PL_MAXIMUM_AMOUNT;

  // validate input amount value
  if (!amountValue || amountValue < plMinAmount) {
    isError = false;
    isWarning = true;
    message = amountLessThanMinMessage(plMinAmount);
  } else if (amountValue > plMaxAmount) {
    isError = false;
    isWarning = true;
    message = amountMoreThanMaxMessage(plMaxAmount, isBroker);
  } else {
    isError = false;
    isWarning = false;
  }

  return {
    isError,
    isWarning,
    message
  };
};

const validateBrokerFee = amountValue => {
  let isError;
  let message = '';

  if (amountValue === undefined) {
    isError = true;
    message = showBrokerFeeEmptyError('Enter a brokerage fee');
  } else if (amountValue > 990) {
    isError = true;
    message = showBrokerFeeGreaterThan990Error();
  }

  return {
    isError,
    message
  };
};

function MainRateWidget(props) {
  const [hasError, setHasError] = useState(false);
  const [hasWarning, setHasWarning] = useState(false);
  const [amountValidationMessage, setAmountValidationMessage] = useState('');

  const [purposeHasChanged, setPurposeHasChanged] = useState(false);
  const [purposeOtherHasChanged, setPurposeOtherHasChanged] = useState(false);

  const showPurposeErrorMessage = 'Select a loan purpose';
  const showPurposeOtherErrorMessage = 'Enter a loan purpose';
  let showAmountErrorMessage;

  const {
    values,
    updateValues,
    stickyQuote,
    result,
    main,
    quote,
    broker,
    showPurposeError,
    showPurposeOtherError,
    showAmountMinError,
    showAmountMaxError,
    getFullSqUrl,
    parentOnChangeEvent,
  } = props;

  const {
    purpose,
    purposeOther,
    loanAmount,
    frequency,
    repaymentPeriod,
    brokerFee
  } = values;

  const {
    setLoanAmount,
    setPurpose,
    setPurposeOther,
    setFrequency,
    setRepaymentPeriod,
    setBrokerFee
  } = updateValues;

  const [brokerFeeHasError, setBrokerFeeHasError] = useState(false);
  const [brokerFeeErrorMessage, setBrokerFeeErrorMessage] = useState(false);

  if (showAmountMinError) {
    const plMinAmount = broker ? PL_BROKER_MINIMUM_AMOUNT : PL_SYMPLE_MINIMUM_AMOUNT;
    showAmountErrorMessage = amountLessThanMinMessage(plMinAmount);
  }

  if (showAmountMaxError) {
    const plMaxAmount = broker ? PL_BROKER_MAXIMUM_AMOUNT : PL_MAXIMUM_AMOUNT;
    showAmountErrorMessage = amountMoreThanMaxMessage(plMaxAmount, broker);
  }
  const aquaTextInfo = broker
    ? "The quoted loan amount and loan term above will be captured in your client's " +
      'application which can be easily updated when you apply.'
    : 'The quoted loan amount and loan term above will be captured in ' +
      'your application which you can easily update when you apply.';
  return (
    <Container stickyQuote={stickyQuote}>
      <MainContent stickyQuote={stickyQuote}>
        {!result && !stickyQuote && (
          <Title>
            {broker && !quote
              ? 'Check your client’s rate'
              : main
              ? 'Check your rate'
              : // default
                'Loan details'}
          </Title>
        )}

        {!quote && !stickyQuote && !result && (
          <Text align={ALIGN.CENTER} marginBottom={MARGIN.M24}>
            {result ? (
              <>
                Use our repayment calculator to work out your repayments. Your{' '}
                <strong>${loanAmount}</strong> loan amount and{' '}
                <strong>{repaymentPeriod} year</strong> loan term will be
                captured when you apply. You can update these details in your
                application.
              </>
            ) : broker ? (
              <>
                We’ll ask you a few quick questions about your client’s
                circumstances and credit history to give you a personalised
                interest rate and repayment amount for a <b>personal loan.</b>
              </>
            ) : (
              // default
              <>
                We’ll ask you a few quick questions about your circumstances and
                credit history to give you a personalised interest rate and
                repayment amount.
              </>
            )}
          </Text>
        )}

        {!quote && !stickyQuote && result && (
          <ResultInfoContainer>
            <StyledText
              align={ALIGN.CENTER}
              fontSize={FONT_SIZE.NORMAL}
              fontWeight={FONT_WEIGHT.SEMI_BOLD}
              color={COLOR.BLACK}
            >
              {aquaTextInfo}
            </StyledText>
          </ResultInfoContainer>
        )}

        <FormFields main={main} broker={broker}>
          <BorrowAmount main={main} broker={broker}>
            <Box className="mb-4">
              <CurrencyInput
                widget
                labelText={
                  props.broker ? "They'd like to borrow" : "I'd like to borrow"
                }
                name="currency-input-story"
                maxLength={10}
                prefix="$"
                value={loanAmount}
                onValueChange={e => {
                  sessionStorage.setItem('loanAmount', e.value);
                  setLoanAmount(e.value);
                  const validationResult = validateLoanAmount(
                    e.floatValue,
                    broker
                  );
                  setHasError(validationResult.isError);
                  setHasWarning(validationResult.isWarning);
                  setAmountValidationMessage(validationResult.message);
                  parentOnChangeEvent && parentOnChangeEvent();
                }}
                showErrorMessage={
                  showAmountErrorMessage || amountValidationMessage
                }
                errorStatus={
                  hasError ||
                  hasWarning ||
                  showAmountMinError ||
                  showAmountMaxError
                }
                showError={
                  hasError ||
                  hasWarning ||
                  showAmountMinError ||
                  showAmountMaxError
                }
              />
            </Box>
          </BorrowAmount>
          <RepaymentPeriod main={main} broker={broker}>
            {repaymentPeriod && (
              <Box className="mb-4">
                <Select
                  widget
                  color={COLOR.BLUE}
                  label="Over a period of"
                  selectedValue={repaymentPeriod}
                  values={repaymentPeriodOptions}
                  onChange={e => {
                    sessionStorage.setItem('repaymentPeriod', e.target.value);
                    setRepaymentPeriod(e.target.value);
                    parentOnChangeEvent && parentOnChangeEvent();
                  }}
                />
              </Box>
            )}
            {result && (
              <Box className="mb-4">
                <Select
                  widget
                  color={COLOR.BLUE}
                  label="Making repayments every"
                  selectedValue={frequency}
                  values={frequencyOptions}
                  onChange={e => {
                    sessionStorage.setItem('frequency', e.target.value);
                    setFrequency(e.target.value);
                    parentOnChangeEvent && parentOnChangeEvent();
                  }}
                />
              </Box>
            )}
          </RepaymentPeriod>
          {broker && result && (
            <Box className="mb-4">
              <CurrencyInput
                widget
                labelText="Broker fee"
                name="broker-fee"
                maxLength={10}
                prefix="$"
                value={brokerFee}
                onValueChange={e => {
                  sessionStorage.setItem('brokerFee', e.value);
                  setBrokerFee(e.value);
                  const validationResult = validateBrokerFee(e.floatValue);
                  setBrokerFeeHasError(validationResult.isError);
                  setBrokerFeeErrorMessage(validationResult.message);
                }}
                showErrorMessage={brokerFeeErrorMessage}
                errorStatus={brokerFeeHasError}
                showError={brokerFeeHasError}
              />
            </Box>
          )}
          <div height="20px;">
          <Link
              className="mx-auto"
              button="primary"
              width="165px"
              href={getFullSqUrl({ isBroker: broker })}
              target="_self"
              trackId="check-your-rate-get-started"
              trackEventData={{
                location: 'check-your-rate',
                category: 'cta',
                action: 'quote-link'
              }}
            >
              Get Rate Estimate
            </Link>
            </div>
        </FormFields>
        {(main || (broker && !result)) && !quote && (
          <>
            <Box marginTop={MARGIN.M16} marginBottom={MARGIN.M16}>
              <ConfettiText
                text={
                  broker
                    ? "This won't effect your client's credit score"
                    : "This won't affect your credit score"
                }
                backgroundColor={`${COLOR.TRANSPARENT}`}
              />
            </Box>
          </>
        )}
      </MainContent>
        <Footer>
        <Text align={ALIGN.CENTER}>
            Already have a rate?{' '}
            {broker && !quote ? (
              <Link
                href={getUrlFromEnv('funnel-start-salesforce-broker-dashboard')}
                target="_self"
                trackEventData={{
                  location: 'check-your-rate'
                }}
                trackId="check-your-rate-retrieve-your-rate-broker"
              >
                Retrieve rate
              </Link>
            ) : (
              <Link
                href={`${getUrlFromEnv(
                  'funnel-start-loans'
                )}${SOFT_QUOTE_LOANS_AU_RETRIEVE_URL}`}
                target="_self"
                trackEventData={{
                  category: 'cta',
                  action: 'quote-retrieval-link',
                  location: 'check-your-rate'
                }}
                trackId="check-your-rate-retrieve-your-rate"
              >
                Retrieve your rate
              </Link>
            )}
          </Text>
          <Text align={ALIGN.CENTER}>
            Here's a link to our{' '}
              <Link
                href="/privacy/"
                target="_self"
                trackEventData={{
                  location: 'check-your-rate'
                }}
                trackId="check-your-rate-privacy-policy"
              >
                Privacy policy
              </Link>
          </Text>
        </Footer>
    </Container>
  );
}

export default MainRateWidget;
